// Package domain types -- iteration 028 (simplified)

export const PACKAGE_STATUSES = ["draft", "active", "archived"] as const;

export type PackageStatus = (typeof PACKAGE_STATUSES)[number];

export interface Package {
  id: string;
  organization_id: string;
  name: string;
  description: string | null;
  status: PackageStatus;
  created_at: Date;
  updated_at: Date;
}

// API response types

export interface PackagePublic {
  id: string;
  organization_id: string;
  organization_name: string;
  name: string;
  description: string | null;
  status: PackageStatus;
  placement_count: number;
  created_at: string;
  updated_at: string;
  _actions: PackageAction[];
}

export type PackageAction = "view" | "edit" | "delete" | "archive";

export interface PackageListResponse {
  packages: PackagePublic[];
}

export interface PackageResponse {
  package: PackagePublic;
}

export interface PackageDetailResponse {
  package: PackagePublic;
}
